// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__XgoBW","imageUploader":"EGiftCard_imageUploader__1bqlK"};